import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import { search, deleteItem } from "actions/admin/actions";
import CommonTable from "views/lib/components/CommonTable";

import Filters from "./filters";

const Admin = ({
                 list,
                 search,
                 deleteItem,
                 history,
               }) => {
  const handleDelete = id => {
    deleteItem(id);
  };

  const handleCreate = () => {
    history.push("/admin/create");
  };

  const getColumns = () => [
    {
      id: "ID",
      Header: "#",
      accessor: "id",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/admin/edit/${original.id}`}>
          {original.id}
        </Link>
      )
    },
    {
      id: "name",
      Header: "Name",
      accessor: "name"
    },
    {
      id: "email",
      Header: "Email",
      accessor: "email"
    },
    {
      id: "roles",
      Header: "Roles",
      accessor: "roles",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.roles.length) {
          return original.roles.map((item, index) => (
            <React.Fragment key={item}>
              <span className="badge badge-success">{item}</span>
              {index < original.roles.length - 1 && <br/>}
            </React.Fragment>
          ));
        }
        return null;
      }
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <React.Fragment>
          <Link to={`/admin/edit/${original.id}`} className="btn btn-sm mx-2 btn-warning">
            <FontAwesomeIcon icon={faPencilAlt}/>
          </Link>
          <Popconfirm
            title={`Are you sure you want to delete <${original.name}> from admins list?`}
            onConfirm={() => handleDelete(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
          <button className="btn btn-sm mx-2 btn-danger">
            <FontAwesomeIcon icon={faTimes}/>
          </button>
          </Popconfirm>
        </React.Fragment>
      )
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={search}
      FiltersComponent={Filters}
      searchHookProps={{
        size: 20,
        sort: "name,ASC"
      }}
      filterComponentProps={{
        handleCreate
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.admin.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  search: bindActionCreators(search, dispatch),
  deleteItem: bindActionCreators(deleteItem, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Admin);



// WEBPACK FOOTER //
// ./src/views/pages/admin/index.js